import { createContext } from 'react'

export const ShowTimesContext = createContext()
